module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 69300.0a926141.png";